import React, { useRef } from "react";
import "../modal.scss";
import TextInput from "../../textInput/TextInput";
import closeIcon from "../../../images/modal/close-icon.svg";
import YellowButton from "../../buttons/defaultButton/yellowButton/YellowButton";
import useOnClickOutside from "../../../helpers/useOnClickOutside";
import { useState } from "react";
import { useEffect } from "react";

const AddModal = ({ title, isOpen, btnTitle, setIsOpen, addElemen }) => {
    const modalRef = useRef();

    useOnClickOutside(modalRef, () => setIsOpen(false));

    const [textInputValue, setTextInputValue] = useState("");

    const onSaveHandler = () => {
        addElemen(textInputValue);
        setIsOpen(false);
    };

    return (
        <>
            {isOpen && (
                <div className="modal-overlay">
                    <div className="modal" ref={modalRef}>
                        <img
                            src={closeIcon}
                            alt="close"
                            className="modal__close-btn"
                            onClick={() => setIsOpen(false)}
                        />
                        <div className="modal__header">{title}</div>
                        <div className="modal__body">
                            <TextInput
                                placeholder={"Заповніть залежність"}
                                inputValue={textInputValue}
                                setInputValue={setTextInputValue}
                            />
                        </div>
                        <div className="modal__footer">
                            <YellowButton text={btnTitle} onClick={() => onSaveHandler(textInputValue)} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

AddModal.defaultProps = {
    title: "Modal title",
    isOpen: false,
    onCancel: () => {},
    onSubmit: () => {},
    children: null,
};

export default AddModal;
